declare let THREE: any;
import {IPointsTransformer} from './PointsTransformer';

export class Points {

  private static readonly unitVec = new THREE.Vector3(1, 1, 1);
  private static readonly error = 0.001;

  public readonly points = new Array(8).fill(0).map(_ => new THREE.Vector3());
  private position = new THREE.Vector3();
  private border = 0;
  private transformMatrix = new THREE.Matrix4();
  private pointsTransformer?: IPointsTransformer;
  private size = new THREE.Vector3();
  private rotationQ = new THREE.Quaternion();
  private halfSizes = new THREE.Vector3();

  constructor(worldMatrix, size, planeProjector?: IPointsTransformer) {
    worldMatrix.decompose(this.position, this.rotationQ, new THREE.Vector3());
    this.size.copy(size);
    this.pointsTransformer = planeProjector;
    this.calculate();
  }

  private calculatePoints() {

    const points = this.points,
      halfSizes = this.halfSizes,
      left = -halfSizes.x,
      right = halfSizes.x,
      back = -halfSizes.z,
      front = halfSizes.z,
      up = halfSizes.y,
      down = -halfSizes.y;

    points[0].set(left, down, front);
    points[1].set(right, down, front);
    points[2].set(left, up, front);
    points[3].set(right, up, front);
    points[4].set(right, down, back);
    points[5].set(left, down, back);
    points[6].set(right, up, back);
    points[7].set(left, up, back);

    this.transformMatrix
      .identity()
      .compose(this.position, this.rotationQ, Points.unitVec);

    points.forEach(point => point.applyMatrix4(this.transformMatrix));
  }

  setPosition(position) {
    this.position.copy(position);
    this.calculate();
    return this;
  }

  setRotation(rotation) {
    this.rotationQ.setFromEuler(rotation);
    this.calculate();
    return this;
  }

  setBorder(border: number) {
    this.border = border;
    this.calculate();
    return this;
  }

  private updateHalfSizes() {
    this.halfSizes
      .copy(this.size)
      .divideScalar(2)
      .addScalar((this.border || 0) - Points.error);
  }

  private calculate() {
    this.updateHalfSizes();
    this.calculatePoints();
    if (this.pointsTransformer) {
      this.pointsTransformer.transform(this.points);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/collision/polygon/Points.ts